import useAdvancedSearch from '../../../hooks/use-advanced-search'
import { AdvancedSearchTable } from '../../aoraki/generic-search-react/src'
import { InlineNotification, LoadingIndicator } from '@msaf/core-react'
import { DISPLAY_DATE_FORMAT } from '@msaf/core-common'

type SearchTypeKey = 'search-assigned-well-dashboard' | 'search-well-dashboard'

interface DashboardSearchProps {
  searchType: SearchTypeKey
  noResultsMessage: string
}
export default function DashboardSearch({ searchType, noResultsMessage }: DashboardSearchProps) {
  const { searchTypeKey, searchTemplate, userPermissions, requestOptions } = useAdvancedSearch({
    searchTypeKey: searchType,
  })

  if (!(searchTemplate && 'authToken' in requestOptions && requestOptions.authToken)) {
    return <LoadingIndicator>Loading&hellip;</LoadingIndicator>
  }
  return (
    <AdvancedSearchTable
      searchTypeKey={searchTypeKey}
      requestOptions={{
        ...requestOptions,
        urlPrefix: `${requestOptions.urlPrefix}/generic-search`,
      }}
      dateFormat={DISPLAY_DATE_FORMAT}
      searchTemplate={searchTemplate}
      pageSize={10}
      currentUserPermissions={userPermissions}
      isTabbedContent={true}
      isShowResultsOnMap={false}
      defaultSortBy={{
        orderColumn: 'councilWellNo',
        orderDirection: 'asc',
      }}
      noResultsComponent={
        <InlineNotification messageType='info' isDismissable={false}>
          {noResultsMessage}
        </InlineNotification>
      }
      isShowResultsCard={false}
      resultsHeading=''
      resultNameSingular='well'
      resultNamePlural='wells'
    />
  )
}
